"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBar = TopBar;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const settings_1 = require("~/settings");
const players_1 = require("~/store/game/players");
const player_1 = require("../ui/player");
const PositionChip_1 = require("../ui/player/PositionChip");
const DebugBar_1 = require("./DebugBar");
const PhaseTimer_1 = require("./PhaseTimer");
const useStyles = (0, react_jss_1.createUseStyles)({
    topBar: {
        "background": "#1d1d1d",
        "padding": "8px 12px",
        "display": "flex",
        "flexDirection": "row",
        "justifyContent": "space-between",
        "alignItems": "center",
        "fontSize": "12px",
        "@media (orientation: portrait) and (max-width: 400px)": {
            fontSize: "10px",
        },
    },
    segment: {
        flex: 1,
        color: "#fff",
        textAlign: "center",
        textTransform: "uppercase",
    },
    left: {
        "textAlign": "left",
        // dirty
        "& > span:not(:last-child)": {
            "marginRight": "8px",
            "@media (orientation: portrait) and (max-width: 400px)": {
                marginRight: "4px",
            },
        },
    },
    right: {
        display: "flex",
        gap: "8px",
        flexDirection: "row",
        justifyContent: "end",
        fontSize: "16px",
    },
    middle: {
        flex: 2,
    },
    container: {
        display: "flex",
        flexDirection: "column",
    },
    levelIcon: {
        "letterSpacing": 0,
        "background": "#333",
        "@media (orientation: portrait) and (max-width: 400px)": {
            fontSize: "10px",
        },
    },
});
function TopBar() {
    var _a, _b;
    const styles = useStyles();
    const showPing = (0, settings_1.useSetting)("showPing");
    const localPlayer = (0, players_1.useLocalPlayer)();
    const position = (0, players_1.usePlayerRank)((_a = localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.id) !== null && _a !== void 0 ? _a : "");
    const round = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.round);
    const health = (_b = localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.health) !== null && _b !== void 0 ? _b : 0;
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.topBar },
            React.createElement("div", { className: (0, classnames_1.default)(styles.segment, styles.left) },
                React.createElement("span", null,
                    "Rnd ",
                    round),
                React.createElement(PhaseTimer_1.PhaseTimer, null)),
            React.createElement("div", { className: (0, classnames_1.default)(styles.segment, styles.middle) },
                React.createElement(player_1.PlayerHealthbar, { health: health })),
            React.createElement("div", { className: (0, classnames_1.default)(styles.segment, styles.right) },
                React.createElement(PositionChip_1.PositionChip, { position: position }))),
        showPing && React.createElement(DebugBar_1.DebugBar, null)));
}
